import { combineReducers } from 'redux'

import authReducer from './auth'



const reducers = combineReducers({
  authReducer,
  

})

export default reducers;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js